import * as ContentPagesEffects from './content-pages.effect';

export const effects = { ...ContentPagesEffects };
